export const arrangeSidebarMenuItems = (items = []) => {
  const hiddenSidebarLabels = ["Sports", "Games", "More"];
  const visibleItems = items.filter((item) => !hiddenSidebarLabels.includes(item?.label));
  const canRedirect = (item) => Boolean(item?.path || item?.externalUrl || item?.action);

  return [
    ...visibleItems.filter(canRedirect),
    ...visibleItems.filter((item) => !canRedirect(item)),
  ];
};
